<template>
  <div class="none">
    <div class="content">
      <div>访问页面不存在，将在3s后返回上一级</div>
      <el-button class="ml-20" @click="goBack">返回上一级</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "fourToFour",
  data() {
    return {
      st: null,
    };
  },
  created() {
    this.st = setTimeout(() => {
      this.goBack();
    }, 3000);
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
  beforeDestroy() {
    clearInterval(this.st);
  },
};
</script>

<style lang="scss" scoped>
.none {
  height: 100%;
  display: flex;
  background: #fff;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .content {
    font-size: 20px;
    align-items: center;
    display: flex;
  }
}
</style>
